<template>
    <div class="verify-code-input">
        <a-input size="large" :value="value" @input="onInput" placeholder="请输入验证码" :maxLength="6">
            <a-button slot="suffix" type="link" class="get-code-button" :disabled="isCounting || loading"
                @click="handleSend">
                {{ loading ? '发送中...' : (isCounting ? `${currentCount}s后重试` : '获取验证码') }}
            </a-button>
        </a-input>
    </div>
</template>

<script>
import {
    getLoginSmsCode, getRegisterSmsCode,
    getFindPasswordSmsCode, getChangePhoneSmsCode
} from '@/api/login';

export default {
    name: 'VerifyCodeInput',
    props: {
        value: {
            type: String,
            default: '',
        },
        phoneNumber: {
            type: String,
            default: '',
        },
        smsCodeType: { // 短信 1=专家 2=供应商 3=通用/其他 
            type: Number,
            default: 1
        },
        sendType: { // login=登录 register=注册 findPassword=找回密码 changePhone=修改手机号
            type: String,
            default: 'login'
        }
    },
    data() {
        return {
            isCounting: false,
            loading: false,
            currentCount: 60,
            timer: null,
        };
    },
    methods: {
        onInput(e) {
            this.$emit('input', e.target.value);
        },
        handleSend() {
            if (this.loading || this.isCounting) return;

            if (!this.phoneNumber) {
                this.$message.warning('请先输入手机号');
                return;
            }
            // Simple phone validation
            if (!/^1[3-9]\d{9}$/.test(this.phoneNumber)) {
                this.$message.warning('请输入正确的手机号');
                return;
            }

            this.loading = true;
            const data = {
                phone: this.phoneNumber,
                smsCodeType: this.sendType === 'changePhone' ? null : this.smsCodeType,
            };
            const Api = {
                login: getLoginSmsCode,
                register: getRegisterSmsCode,
                findPassword: getFindPasswordSmsCode,
                changePhone: getChangePhoneSmsCode
            }[this.sendType];
            if (!Api) {
                this.$message.error('未知的发送类型');
                this.loading = false;
                return;
            }
            Api(data).then(res => {
                if (res) {
                    this.$message.success('验证码已发送');
                    this.$emit('send-success');
                    this.startCountdown();
                } else {
                    this.$message.success('发送失败');
                }

            }).catch(err => {
                // Error handling is done by request interceptor usually, but if not:
                // this.$message.error(err.message || '发送失败');
            }).finally(() => {
                this.loading = false;
            });
        },
        startCountdown() {
            this.isCounting = true;
            this.currentCount = 60;
            this.timer = setInterval(() => {
                if (this.currentCount > 0) {
                    this.currentCount--;
                } else {
                    this.stopCountdown();
                }
            }, 1000);
        },
        stopCountdown() {
            this.isCounting = false;
            this.currentCount = 60;
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
        },
    },
    beforeDestroy() {
        this.stopCountdown();
    },
};
</script>

<style lang="less" scoped>
@import '../styles/variables.less';

.verify-code-input {
    /deep/ .ant-input {
        height: 40px;
        font-family: @font-pingfang-sc;
        font-weight: 400;
        color: #8e929e;
        font-size: 16px;
        border-color: #dbdce7;
        border-radius: 4px;
    }

    .get-code-button {
        border: none;
        background: transparent;
        font-size: 14px;

        &[disabled] {
            color: rgba(0, 0, 0, 0.25);
        }
    }
}
</style>
